<template>
  <div class="m-3 rounded shadow-lg flex flex-col bg-gray-800">
    <h3 v-if='state !== "error"' class="bg-gray-500 p-1 text-xl text-center text-gray-900 font-bold">{{heading}}</h3>
    <img :src='img' class="object-fit h-64" />
    <h2 v-if='message.length' class="bg-gray-900 p-1 text-center text-gray-700 font-bold">{{message}}</h2>

    <div class="flex justify-center pt-2 pb-2 bg-gray-500">
      <pbc-button @click="$emit('restart')">
        <div class="font-bold text-lg p-2">
          {{buttonTitle}}
        </div>
      </pbc-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    state: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: ''
    }
  },
  computed: {
    heading() {
      if (this.state === "win") {
        return "You Win!";
      } else if (this.state === "gameover" || this.state === "lose") {
        return "Game Over";
      } else {
        return "Restart"
      }
    },
    img() {
      if (this.state === "win") {
        return '/img/PBC_GameWin.svg';
      } else if (this.state === "error") {
        return '/img/PBC_GameError.svg'
      } else {
        return '/img/PBC_GameOver.svg'
      }
    },
    buttonTitle() {
      if (this.state === "gameover" || this.state === "lose") {
        return "Try Again";
      } else {
        return "Restart";
      }
    }
  }
}
</script>
